import styled from 'styled-components'

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;

  @media (min-width: 1200px) {
    padding-top: 10px;
  }

  strong {
    font-weight: 600;
  }
`

export const Attribute = styled.div`
  display: flex;
  flex-direction: column;
  height: 50px;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 30px;
  width: 100%;
  align-content: space-between;
`

export const Label = styled.p`
  font-weight: 500;
  margin-bottom: 0;
`

export const Value = styled.p`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
`

export const ChangeButton = styled.a`
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  padding: 8px 20px;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.palette.primary.main};
    color: #ffffff;
    text-decoration: none;
  }
`
